import React from 'react'

import { OrderSyncErrorCell } from './OrderSyncErrorCell'

import { MyRowProps } from '../../types/tableTypes'
import { OzonOrderModel } from '../../server/mpsklad_core/Models/Orders/OzonOrderModel'

export const OzonOrderSyncErrorCell =
  ({row}: MyRowProps<OzonOrderModel>) =>
    <OrderSyncErrorCell type={'Ozon'} row={row}/>